module.exports = __webpack_public_path__ + "img/pic-heart.09ce894.svg";